module.exports = __webpack_public_path__ + "assets/sub-doc.1fd61305.svg";